// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Simplert from 'vue2-simplert'
import VueTimeago from 'vue-timeago'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import 'font-awesome/css/font-awesome.css'

import { dateAndTime } from './mixins/dateAndTime'

import App from './App'
import router from './router'

import IArrow from './components/base/IArrow'

import Moment from 'moment'
import MomentDurationFormatSetup from 'moment-duration-format'
import VueMoment from 'vue-moment'

Vue.config.productionTip = false

MomentDurationFormatSetup(Moment)

VueMoment.install(Vue, { 'moment': Moment })

Vue.use(VueTimeago, {
  name: 'timeago', // component name, `timeago` by default
  locale: 'en-US',
  locales: {
    // you will need json-loader in webpack 1
    'en-US': require('vue-timeago/locales/en-US.json')
  }
})

Vue.component('qrcode', VueQrcode)
Vue.component('simplert', Simplert)
Vue.component('v-iarrow', IArrow)

Vue.filter('capitalize', function (value) {
  if (!value) {
    return ''
  }
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('formatPlc', function (amount) {
  const amount_formatted = Number(amount.toFixed(8))
  return amount_formatted.toString() + ' PLC'
})

Vue.mixin({
  methods: {
    'txConfirmationsArrowColor': function (tx) {
      const cuts = (tx.inputsValue === 0 ? 101 : 6)
      const position = tx.confirmations
      let color = '00ff00'

      if (position > cuts) {
        return '#00ff00'
      }

      if (position <= cuts / 2) {
        color = 'ff' + Math.round(255 * position / cuts).toString(16).padStart(2, '0') + '00'
      } else {
        color = (255 - Math.round(255 * position / cuts)).toString(16).padStart(2, '0') + 'ff00'
      }

      return '#' + color
    }
  }
})

Vue.mixin(dateAndTime)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js